// src/campaigns/engine/campaign-helpers.ts

import { CampaignDefinition } from "../types/campaign.types";
import { fromISODate } from "./campaign-date.utils";

export function getTodayISO(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, "0");
  const day = `${now.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getActiveCampaign(
  campaigns: CampaignDefinition[],
  todayISO = getTodayISO()
): CampaignDefinition | null {
  const today = fromISODate(todayISO).getTime();

  return (
    campaigns.find((campaign) => {
      const start = fromISODate(campaign.startDate).getTime();
      const end = fromISODate(campaign.endDate).getTime();

      return today >= start && today <= end;
    }) || null
  );
}

export function getNextCampaign(
  campaigns: CampaignDefinition[],
  todayISO = getTodayISO()
): CampaignDefinition | null {
  const today = fromISODate(todayISO).getTime();

  return campaigns.find((campaign) => fromISODate(campaign.startDate).getTime() > today) || null;
}

export function getCampaignBySlug(
  campaigns: CampaignDefinition[],
  slug?: string | null
): CampaignDefinition | null {
  if (!slug) return null;
  return campaigns.find((campaign) => campaign.slug === slug) || null;
}

export function getCampaignById(
  campaigns: CampaignDefinition[],
  id?: string | null
): CampaignDefinition | null {
  if (!id) return null;
  return campaigns.find((campaign) => campaign.id === id) || null;
}

export function getAbsoluteCampaignImageUrl(imagePath: string): string {
  const baseUrl =
    process.env.REACT_APP_APP_URL ||
    process.env.REACT_APP_SITE_URL ||
    "https://lrnsy.electrixitaty.com";

  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  return `${baseUrl}${imagePath.startsWith("/") ? imagePath : `/${imagePath}`}`;
}

export function createCampaignCreatePath(campaign: CampaignDefinition): string {
  const query = new URLSearchParams({
    archetype: campaign.archetype,
    campaign: campaign.slug,
  });

  return `/create?${query.toString()}`;
}
